module.exports = __webpack_public_path__ + "img/reservation-complete.8ac0ae8a.png";